
export default {
	name: "AppStoreButtons",
	data() {
		return {
			storeUrls: {
				ios: "https://apps.apple.com/us/app/wordfinder-by-yourdictionary/id1436464468",
				android:
					"https://play.google.com/store/apps/details?id=com.lovetoknow.wordfinder&hl=en",
			},
		};
	},
};
